import Cookies from 'js-cookie'

// 当前登录用户token
const TokenKey = 'classkit'

export function getToken() {
  return Cookies.get(TokenKey)
}

export function setToken(token) {
  return Cookies.set(TokenKey, token)
}

export function removeToken() {
  return Cookies.remove(TokenKey)
}

// 后台管理员，临时登录其他人账户时，
// 所使用的临时token
const TempUserTokenKey = 'classkit-temp-user'

export function getTempToken() {
  return Cookies.get(TempUserTokenKey)
}

export function setTempToken(token) {
  return Cookies.set(TempUserTokenKey, token)
}

export function removeTempToken() {
  return Cookies.remove(TempUserTokenKey)
}


// WEBPACK FOOTER //
// ./src/utils/auth.js